export const baseURL = '/api'

export const formatStrAddress = (left: number, right: number, str: string) =>
  str.substring(0, left) + new Array(4).join('.') + str.substring(str.length - right, str.length)

export const Adapth5 = 768
